export default __webpack_public_path__ + "static/media/icon-warn.a49fe0a6.svg";